export const appStore = "https://apps.apple.com/in/app/smoothie-factory/id1642957984"
export const playStore = "https://play.google.com/store/apps/details?id=com.smoothie_mobile"